<template>
  <div class="userLog-main-content">
    <div class="search">
      <el-form class="searchForm" :model="searchForm">
        <el-form-item>
          <el-input size="small" :min-width="100" v-model="searchForm.keyword" placeholder="输入账号、操作内容...."></el-input>
        </el-form-item>

        <el-form-item>
          <el-select clearable size="small" v-model="searchForm.logType" placeholder="操作类型">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="table">
      <el-table stripe size="medium" :data="list" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column label="操作内容" align="center" min-width="150">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" type="info">用户登录</el-tag>
            <el-tag v-if="scope.row.type === 2" type="success">用户注册</el-tag>
            <el-tag v-if="scope.row.type === 3" type="danger">查看配件详情</el-tag>
            <el-tag v-if="scope.row.type === 4" type="primary">搜索配件列表</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="email" label="用户账号" min-width="150"></el-table-column>
        <el-table-column label="操作时间" align="center" min-width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="detail" label="详细信息" min-width="280"></el-table-column>


        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination :params="pageParams" @pageList="pageList"></Pagination>
    </div>
  </div>
</template>

<script>
import { userLog_page, userLog_del, user_refresh_token } from "../api/api";
import './../assets/css/userLog.css';
import Pagination from "../components/Pagination";

export default {
  data() {
    return {
      timer: null, // 定时器
      // 搜索表单
      searchForm: {
        keyword: '',
        logType: null
      },
      // 分页表单
      pageParams: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 列表
      list: [],

      typeList: [
        { value: 1, label: '登录' },
        { value: 2, label: '注册' },
        { value: 3, label: '查看配件详情' },
        { value: 4, label: '搜索配件' }
      ],
    };
  },
  // 注册组件
  components: { Pagination },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.page(this.pageParams.currentPage, this.pageParams.pageSize);
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken()
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "userlog", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    // ----------------------search start---------------------
    search() {
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    // 分页插件事件
    pageList(currentPage, pageSize) {
      this.page(currentPage, pageSize);
    },
    // 分页查询
    async page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;

      param.type = this.searchForm.logType;
      param.keyword = this.searchForm.keyword;

      const data = await userLog_page(param);

      this.pageParams.total = data.data.total;
      this.pageParams.pageSize = data.data.pageSize;
      this.pageParams.currentPage = data.data.currentPage;
      this.list = data.data.list;

      if (this.pageParams.total > 0 && this.pageParams.total == (this.pageParams.currentPage - 1) * this.pageParams.pageSize) {
        this.page(this.pageParams.currentPage - 1, this.pageParams.pageSize);
      } else {
        this.list = data.data.list;
      }
    },
    // ----------------------search end---------------------


    // ----------------------delete start-------------------
    // 删除记录
    handleDelete(index, id) {
      this.delConfirm(index, id);
    },
    //删除确认对话框
    delConfirm(index, id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          userLog_del(id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.list.splice(index, 1);
              this.page(
                this.pageParams.currentPage,
                this.pageParams.pageSize
              );
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------delete end---------------------
  }
};
</script>





// WEBPACK FOOTER //
// src/views/UserLog.vue